import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router5';
import * as Actions from '../common/services/actions';
import configureStore from '../common/services/store';
import router from '../common/routes/router';
import Events from '../listings/events/events';
import EventsTabs from '../listings/events/eventsTabs';

let store;

function EventsApp() {
	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<Events />
			</RouterProvider>
		</Provider>
	);
}

function EventsTabApp() {
	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<EventsTabs />
			</RouterProvider>
		</Provider>
	);
}

export function renderEvents(id,  mg, auth, micrositeRender, showcase, companyName) {
	if (!store) {
		store = configureStore(router);
	}
	store.dispatch(Actions.initialiseSettings('events', '', '', micrositeRender, '', companyName));
	router.start(() => {
		ReactDOM.render(<EventsApp />, document.getElementById(id));
	});
}

export function renderEventsTab(id) {
	if (!store) {
		store = configureStore(router);
	}
	store.dispatch(Actions.initialiseSettings('events'));
	router.start(() => {
		ReactDOM.render(<EventsTabApp />, document.getElementById(id));
	});
}